(() => {
  if (customElements.get('sn-cz-collection')) return;

  class SnCzCollection extends HTMLElement {
    connectedCallback() {
      this.events?.abort();
      this.events = new AbortController();
      const { signal } = this.events;
      this.grid = this.querySelector('[data-czc-grid]');
      this.items = Array.from(this.querySelectorAll('[data-czc-category]'));
      this.filters = Array.from(this.querySelectorAll('[data-czc-filter]'));
      this.columnButtons = Array.from(this.querySelectorAll('[data-czc-columns]'));
      this.sortControl = this.querySelector('[data-czc-sort]');
      this.sidebar = this.querySelector('[data-czc-sidebar]');
      this.toggle = this.querySelector('[data-czc-toggle]');
      this.count = this.querySelector('[data-czc-count], .sn-czc-result-count');
      if (!this.grid) return;

      this.featuredOrder ||= new WeakMap();
      this.items.forEach((item, index) => {
        if (!this.featuredOrder.has(item)) this.featuredOrder.set(item, index);
      });
      this.countTemplate = this.dataset.czcCountTemplate
        || this.count?.dataset.czcCountTemplate
        || '{count} sets';
      this.category = 'all';
      this.compactViewport = window.matchMedia('(max-width: 991px)');

      this.addEventListener('click', (event) => {
        if (!(event.target instanceof Element)) return;
        const button = event.target.closest('[data-czc-filter], [data-czc-columns], [data-czc-toggle]');
        if (!button || !this.contains(button)) return;

        if (button.hasAttribute('data-czc-filter')) {
          this.filter(button.dataset.czcFilter);
        } else if (button.hasAttribute('data-czc-columns')) {
          this.setColumns(button.dataset.czcColumns);
        } else {
          this.setSidebarHidden(!this.classList.contains('sn-czc-sidebar-hidden'));
        }
      }, { signal });

      this.sortControl?.addEventListener('change', () => this.render(), { signal });
      this.addEventListener('shopify:block:select', () => this.filter('all'), { signal });
      this.compactViewport.addEventListener('change', () => this.updateViewport(), { signal });

      this.updateViewport();
      this.render();
      this.querySelectorAll('[data-czc-controls]').forEach((control) => {
        control.hidden = false;
      });
    }

    updateViewport() {
      this.setSidebarHidden(this.compactViewport.matches);
      this.setColumns(this.compactViewport.matches ? '2' : '4');
    }

    setSidebarHidden(hidden) {
      this.classList.toggle('sn-czc-sidebar-hidden', hidden);
      this.toggle?.setAttribute('aria-expanded', String(!hidden));
      if (hidden && this.sidebar?.contains(document.activeElement)) this.toggle?.focus();
    }

    setColumns(columns) {
      if (!this.columnButtons.some((button) => button.dataset.czcColumns === columns)) return;
      this.grid.dataset.columns = columns;
      this.columnButtons.forEach((button) => {
        button.setAttribute('aria-pressed', String(button.dataset.czcColumns === columns));
      });
    }

    filter(category) {
      if (category !== 'all' && !this.filters.some((button) => button.dataset.czcFilter === category)) return;
      this.category = category;
      this.render();
    }

    render() {
      const sort = this.sortControl?.value || 'featured';
      const ordered = [...this.items].sort((left, right) => {
        let difference = 0;
        if (sort === 'title-ascending' || sort === 'title-descending') {
          difference = (left.dataset.czcTitle || '').localeCompare(
            right.dataset.czcTitle || '', document.documentElement.lang || undefined,
            { sensitivity: 'base', numeric: true }
          );
        } else if (sort === 'price-ascending' || sort === 'price-descending') {
          difference = Number(left.dataset.czcPrice) - Number(right.dataset.czcPrice);
        }
        if (sort.endsWith('-descending')) difference *= -1;
        return difference || this.featuredOrder.get(left) - this.featuredOrder.get(right);
      });
      this.grid.append(...ordered);

      let count = 0;
      this.items.forEach((item) => {
        item.hidden = this.category !== 'all' && item.dataset.czcCategory !== this.category;
        if (!item.hidden) count += 1;
      });
      this.filters.forEach((button) => {
        button.setAttribute('aria-pressed', String(button.dataset.czcFilter === this.category));
      });
      if (this.count) this.count.textContent = this.countTemplate.replace('{count}', String(count));
    }

    disconnectedCallback() {
      this.events?.abort();
    }
  }

  customElements.define('sn-cz-collection', SnCzCollection);
})();
